import { NavLink, Link, useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import { Menu, X } from "lucide-react";

const links = [
  { to: "/leadership",                    label: "Leadership" },
  { to: "/leadership/biography",          label: "Biography" },
  { to: "/leadership/expertise",          label: "Focus" },
  { to: "/leadership/thought-leadership", label: "Thought Leadership" },
  { to: "/leadership/media",              label: "Media" },
  { to: "/leadership/speaking",           label: "Speaking" },
  { to: "/leadership/contact",            label: "Contact" },
];

export default function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  const loc = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => { setOpen(false); }, [loc.pathname]);

  return (
    <header
      data-testid="site-header"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md" : "bg-white"
      } border-b border-[#E2E8F0]`}
    >
      <div className="max-w-[1440px] mx-auto px-6 md:px-12 lg:px-16 h-16 flex items-center justify-between">
        <Link
          to="/leadership"
          data-testid="header-brand-link"
          className="flex items-baseline gap-3"
        >
          <span className="font-serif text-[1.35rem] leading-none text-[#0A1128] tracking-tight">
            Adeshi&nbsp;Moffi
          </span>
          <span className="hidden sm:inline eyebrow text-[#8E7331]">
            Investors&nbsp;Pathway
          </span>
        </Link>

        <nav className="hidden lg:flex items-center gap-8" data-testid="primary-nav">
          {links.map((l) => (
            <NavLink
              key={l.to}
              to={l.to}
              end={l.to === "/leadership"}
              data-testid={`nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
              className={({ isActive }) =>
                `text-[0.78rem] uppercase tracking-[0.18em] font-sans font-medium transition-colors duration-200 ${
                  isActive ? "text-[#0A1128]" : "text-[#475569] hover:text-[#0A1128]"
                }`
              }
            >
              {l.label}
            </NavLink>
          ))}
        </nav>

        <div className="hidden lg:flex">
          <Link to="/leadership/contact" data-testid="header-cta-schedule" className="btn-ink">
            Schedule <span aria-hidden>›</span>
          </Link>
        </div>

        <button
          type="button"
          onClick={() => setOpen((v) => !v)}
          data-testid="header-mobile-toggle"
          className="lg:hidden inline-flex items-center justify-center w-10 h-10 border border-[#0A1128] text-[#0A1128]"
          aria-label={open ? "Close menu" : "Open menu"}
        >
          {open ? <X size={18} /> : <Menu size={18} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden border-t border-[#E2E8F0] bg-white" data-testid="mobile-nav">
          <div className="max-w-[1440px] mx-auto px-6 py-4 flex flex-col gap-1">
            {links.map((l) => (
              <NavLink
                key={l.to}
                to={l.to}
                end={l.to === "/leadership"}
                data-testid={`mobile-nav-link-${l.label.toLowerCase().replace(/\s+/g, "-")}`}
                className={({ isActive }) =>
                  `py-3 border-b border-[#E2E8F0] text-sm uppercase tracking-[0.18em] font-sans ${
                    isActive ? "text-[#0A1128] font-semibold" : "text-[#475569]"
                  }`
                }
              >
                {l.label}
              </NavLink>
            ))}
            <Link to="/leadership/contact" data-testid="mobile-cta-schedule" className="btn-ink mt-4 justify-center">
              Schedule a Consultation
            </Link>
          </div>
        </div>
      )}
    </header>
  );
}
